const ACTIVE = 'ACTIVE';
const INACTIVE = 'INACTIVE';
const DEAD = 'DEAD';

export const PIECE_STATUS = {
    ACTIVE,
    INACTIVE,
    DEAD,
}

export const PIECE_STATUS_CODE = {
    [DEAD]: 2,
    [ACTIVE]: 0,
    [INACTIVE]: 1,
} 